import { AxiosInstance } from "axios";

/**
 * Profile API endpoints for the signed-in user
 * Platform-agnostic - works with any HTTP client
 */
export class ProfileApi {
  constructor(private client: AxiosInstance) {}

  /**
   * Store the language the user picked in the app, so emails are sent in it.
   * The region accepts en, de, fr and es (or a regional variant of one).
   */
  async setLanguage(language: string): Promise<void> {
    await this.client.put("/api/profile/language", { language });
  }
}
